<div class="container-fluid main-container m-0 p-0 pb-4 h-100">
	<div class="background-overlay">
		<div
			*ngIf="userProfile.darkMode"
			class="background-overlay-image"
		></div>
		<div
			[ngClass]="{'light': !userProfile.darkMode }"
			class="background-overlay-color"
		></div>
	</div>
	<div class="row m-0 p-0 justify-content-end">
		<div class="col-xl-5 col-12 main-title">
			<div class="jumbotron">
				<h1 class="display-2">{{ 'home.welcome' | translate }}</h1>
				<p class="lead">{{ 'home.welcomeMessage1' | translate }}</p>
				<p class="lead">{{ 'home.welcomeMessage2' | translate }}</p>
			</div>
		</div>
	</div>

	<div class="row m-0 h-100 fav-card-container">
		<div class="col-12 col-md-6 secondary-title small-space-area">
			<div class="jumbotron">
				<h1 class="display-4">
					{{'home.contracts.title' | translate}}
				</h1>
				<div class="contract-counter">
					{{ "home.contracts.showing_1" | translate }}<strong
						>{{ this.filteredServices?.length }}</strong
					>{{ "home.contracts.showing_2" | translate }}{{
					this.allServices?.length }}
				</div>
			</div>
		</div>
		<div class="col-12 col-md-6 tag-filter-container">
			<div class="filter-tags">
				<mat-chip-set>
					<mat-chip
						(click)="removeTag(tag)"
						class="tag"
						*ngFor="let tag of selectedTagsDepartment; let i = index"
					>
						<div class="tag-content">
							<mat-icon
								class="tag-close-button filter_alt_off"
								aria-hidden="false"
								aria-label="close"
								fontIcon="filter_alt_off"
							></mat-icon>
							<div>{{ getTagName(tag) | translate }}</div>
						</div>
					</mat-chip>
					<mat-chip
						(click)="removeTag(tag)"
						class="tag"
						*ngFor="let tag of selectedTagsCountry; let i = index"
						><div class="tag-content">
							<mat-icon
								class="tag-close-button filter_alt_off"
								aria-hidden="false"
								aria-label="close"
								fontIcon="filter_alt_off"
							></mat-icon>
							<div>{{ getTagName(tag) | translate }}</div>
						</div>
					</mat-chip>
					<mat-chip
						(click)="removeTag(tag)"
						class="tag"
						*ngFor="let tag of selectedTagsProyectType; let i = index"
						><div class="tag-content">
							<mat-icon
								class="tag-close-button filter_alt_off"
								aria-hidden="false"
								aria-label="close"
								fontIcon="filter_alt_off"
							></mat-icon>
							<div>{{ getTagName(tag) | translate }}</div>
						</div>
					</mat-chip>
				</mat-chip-set>
			</div>
			<div
				(click)="toggleFavouritesServices()"
				class="filter-fav-button mat-elevation-z3"
			>
				<div
					[ngClass]="filterFavouriteServices ? 'fav' : 'unfav'"
				></div>
			</div>
			<div
				(click)="toggleFilters()"
				[ngClass]="displayFilters ? 'selected' : 'non-selected'"
				class="filter-button mat-elevation-z3"
			>
				<mat-icon
					class="tag-close-button filter_alt"
					aria-hidden="false"
					aria-label="close"
					fontIcon="filter_alt"
				></mat-icon>
				<div>{{ "home.contracts.filter.title" | translate }}</div>
			</div>
		</div>
		<div
			*ngIf="displayFilters && departments.length > 0 && projectTypes.length > 0 && countries.length > 0"
			class="col-12 filter-panel"
		>
			<mat-form-field
				class="col-12 col-md-6 col-lg-4 col-xl-3 filter-input"
			>
				<mat-label
					>{{ "home.contracts.filter.department" | translate
					}}</mat-label
				>
				<mat-select
					[formControl]="departmentForm"
					multiple
					(selectionChange)="departmentSelectionChanged($event)"
				>
					<mat-select-trigger>
						{{ ("departments." + departmentForm.value?.[0] |
						translate) || ''}}
						<span
							*ngIf="(departmentForm.value?.length || 0) > 1"
							class=""
						>
							(+{{(departmentForm.value?.length || 0) - 1}}
							{{departmentForm.value?.length === 2 ?
							("home.contracts.filter.other" | translate) :
							("home.contracts.filter.others" | translate)}})
						</span>
					</mat-select-trigger>
					<mat-option
						*ngFor="let tag of tagsDepartment"
						[value]="tag.tag"
						>{{ "departments." + tag.tag | translate }}</mat-option
					>
				</mat-select>
			</mat-form-field>

			<mat-form-field
				class="col-12 col-md-6 col-lg-4 col-xl-3 filter-input"
			>
				<mat-label
					>{{ "home.contracts.filter.country" | translate
					}}</mat-label
				>
				<mat-select
					[formControl]="countryForm"
					multiple
					(selectionChange)="countrySelectionChanged($event)"
				>
					<mat-select-trigger>
						{{ ("countries." + countryForm.value?.[0] | translate)
						|| ''}}
						<span
							*ngIf="(countryForm.value?.length || 0) > 1"
							class=""
						>
							(+{{(countryForm.value?.length || 0) - 1}}
							{{countryForm.value?.length === 2 ?
							("home.contracts.filter.other" | translate) :
							("home.contracts.filter.others" | translate)}})
						</span>
					</mat-select-trigger>
					<mat-option
						*ngFor="let tag of tagsCountries"
						[value]="tag.tag"
						>{{ "countries." + tag.tag | translate }}</mat-option
					>
				</mat-select>
			</mat-form-field>

			<mat-form-field
				class="col-12 col-md-6 col-lg-4 col-xl-3 filter-input"
			>
				<mat-label
					>{{ "home.contracts.filter.projectType" | translate
					}}</mat-label
				>
				<mat-select
					[formControl]="projectTypeForm"
					multiple
					(selectionChange)="projectTypeSelectionChanged($event)"
				>
					<mat-select-trigger>
						{{ projectTypeForm.value?.[0] || ''}}
						<span
							*ngIf="(projectTypeForm.value?.length || 0) > 1"
							class=""
						>
							(+{{(projectTypeForm.value?.length || 0) - 1}}
							{{projectTypeForm.value?.length === 2 ?
							("home.contracts.filter.other" | translate) :
							("home.contracts.filter.others" | translate)}})
						</span>
					</mat-select-trigger>
					<mat-option
						*ngFor="let tag of tagsProjectType"
						[value]="tag.tag"
						>{{ "site.type." + tag.tag | translate }}</mat-option
					>
				</mat-select>
			</mat-form-field>
		</div>
		<div class="row m-0 p-0">
			<div
				class="col-12 col-md-6 col-lg-4 col-xl-3 fav-card"
				*ngFor="let cebe of (filteredServices | sort:'codigo').slice(0, this.page * this.pageSize)"
			>
				<app-cebes-card
					chartdivId="{{'card-chart-' + cebe['codigo']}}"
					[cebe]="cebe"
					(favEvent)="favCebe($event)"
					(unfavEvent)="unfavCebe($event)"
				>
				</app-cebes-card>
			</div>
			<div
				class="load-more-button"
				*ngIf="filteredServices?.length > this.page * this.pageSize"
				(click)="loadMore()"
			>
				{{ "home.contracts.loadMore" | translate }}
			</div>
		</div>
	</div>

	<div class="chart-container">
		<app-globe-map
			[darkMode]="userProfile.darkMode"
			[countries]="countries"
		>
		</app-globe-map>
	</div>

	<div class="bg-smooth"></div>
	<router-outlet></router-outlet>
</div>
